/* eslint-disable indent */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Form,
  Col,
  Input,
  Tooltip,
  Select,
  AutoComplete,
  Button,
  Spin,
  message,
} from "antd";
import {
  checkAlphabets,
  checkAlphabetsAndNumber,
  checkNumbervalue,
  preventTextPaste,
  checkSpace,
  checkSpecialCharacter,
  firstLetterCapitaliseDropDown,
  isValidDocumentNum,
} from "../../../../utils";
import useClientAndDepartment from "../../CrediteBooking/useClientAndDepartment ";
import { HeaderWithBottomLine } from "../../../Master/CpOnbordingSteps/HeaderWithBottomLine";
import AutoCompleteAddress from "../../CrediteBooking/AutoCompleteAddress";
import { ReciverAddressComponent } from "../../../../components/ReciverAddressComponent";
import { ReactComponent as AttachFile } from "../../../../assests/images/FileEarmarkPlus.svg";
import { SenderFormFields } from "./senderForm";
import { DiffOutlined } from "@ant-design/icons";

import API from "../../../../api";
import urls from "../../../../api/urls";
import Smcs_Loader from "../../../../assests/images/loader-new.gif";
import RetailDoxAndNonDox from "./RetailDoxAndNonDox";
import AutoSenderName from "./AutoSenderName";

function NewRetailForm({
  // Loading & Callback Functions
  retailLoading,
  ewayDrawercallBack,
  childDrawerCallBack,
  eWayBillHandle,

  // Form and Validation
  form,
  docValidate,
  setDocValidate,
  documentValidate,
  resetForm,
  setMainEwayValidationStatus,
  mainEwayValidationStatus,
  setSenderPinCodeServiceableStatus,
  senderPinCodeServiceableStatus,

  // Freight and Packet Changes
  onFreightChange,
  onPacketChange,

  // Options and Configurations
  insuredOptions,
  travelByOptions,
  servicesOptions,
  pinCodeServiceableStatus,
  contentDiscriptionData,
  setServiceOptions,

  // Eway Bills & Child Shipments
  allEwayBills,
  childShipments,
  setChildShipments,

  // Reviver & Address Details
  reviverNameAndAddress,
  getRecvNameAddressList,
  setPinCodeServiceableStatus,
  getDeliveryPincode,
  getContentDiscriptionData,
  getSenderPincode,

  // Travel and Rate Card
  mainBaseCharge,
  getRateCard,

  // Miscellaneous
  loading,
  handleOnEnter,

  isNonDox,
  setIsNonDox,
  removeFocusEffect,
  applyFocusEffect,
  setAddressOptions,
  addressOptions,
  setAllEwayBills,
  setdocLoading,
  isODAIncluded,

  checkGST,
  checkGSTStatus,
  editAwb,
  pincodeLoading,

  enableDiscount,
  enableForm,
}) {
  const { VERIFY_GST } = urls;
  // const currentEnv = process.env.REACT_APP_ENV;

  const { userInfo, premises } = JSON.parse(
    window?.localStorage?.getItem("userId")
  );

  // const [ewayBill, setEwayBill] = useState(false);
  // const userId = JSON.parse(localStorage.getItem("userId"));
  // const [serviceType, setServiceType] = useState("STANDARD");

  const [shipmentContentOptions, setShipmentContentOptions] = useState([]);
  const [dropDownChanges, setdropDownChanges] = useState(false);
  // const [documentNumber, setDocumentNumber] = useState("");

  const debounceTimeout = useRef(null);
  const debounceTimeoutPin = useRef(null);

  const [activePinOption, setActivePinOption] = useState(null);

  const [allPincodes, setAllPincodes] = useState([]);

  const [allPinOptions, setAllPinOptions] = useState([]);
  const [ewayBillCheck, setEwayBillCheck] = useState(false);
  const [insurenceCheck, setInsurenceCheck] = useState(true);
  const [selectedKycType, setSelectedKycType] = useState("AADHAAR");

  useEffect(() => {
    try {
      const jsonData = JSON?.parse(localStorage?.getItem("allPincodes"));
      setAllPincodes(jsonData);
    } catch (error) {
      console.error("Invalid JSON:", error);
    }
  }, []);

  let sezOptions = [
    {
      value: "NO",
      label: "NO",
    },
    { value: "YES", label: "YES" },
  ];
  let payOptions = [
    {
      value: "ONLINE",
      label: "ONLINE",
    },
    { value: "CASH", label: "CASH" },
  ];

  const doxandNonDoxChange = {
    content: null,
    description: null,
    weight: null,
    length: null,
    width: null,
    height: null,
    volumatricWeight: null,
    child_Selected: false,
    value: null,
  };

  useEffect(() => {
    if (Object.entries(contentDiscriptionData)?.length !== 0) {
      form.setFieldsValue({
        shipmentType: "DOX",
      });

      handleShipmentTypeChange("_", { key: 1, value: "DOX" });
    }
  }, [contentDiscriptionData]);

  const handleShipmentTypeChange = (_, { key, value }) => {
    form.setFieldValue("content", null);
    const isDox = value?.toUpperCase() == "NON-DOX" ? "NON-DOX" : "DOX";
    setIsNonDox(isDox);
    if (isDox == "NON-DOX") {
      form.setFieldsValue(doxandNonDoxChange);
      //   setChilldShipmentLength(0);
      setChildShipments([]);
      form.setFieldsValue({
        value: "0",
        weight: "1",
      });
    } else {
      form.setFieldsValue({
        value: "0",
        weight: 50,
      });
    }

    let output = [];

    contentDiscriptionData?.shipmentContent?.forEach((content) => {
      let filteredDescriptions =
        contentDiscriptionData?.shipmentDescription?.filter((description) => {
          return (
            description?.shipmentContentId === content?.shipmentContentId &&
            content?.shipmentTypeId === +key
          );
        });

      filteredDescriptions?.forEach((description) => {
        let combinedName = `${content?.shipmentContentName} - ${description?.shipmentDescriptionName}`;
        output.push({
          shipmentContentId: content?.shipmentContentId,
          shipmentContentName: combinedName?.toUpperCase(),
          shipmentTypeId: content?.shipmentTypeId,
        });
      });
    });
    setShipmentContentOptions(output);
  };
  const autoCompleteOptions = shipmentContentOptions?.map((option) => ({
    value: option?.shipmentContentName?.toUpperCase(),
    label: option?.shipmentContentName?.toUpperCase(),
  }));

  const filterOption = (input, option) =>
    (option?.children ?? "").toLowerCase()?.includes(input?.toLowerCase());

  const resetActiveState = () => {
    document.querySelectorAll(".ant-select-item-option")?.forEach((option) => {
      option.classList.remove("ant-select-item-option-active");
    });
  };

  useEffect(() => {
    resetActiveState();
  }, [dropDownChanges]);

  useEffect(() => {
    const handleTabPress = (event) => {
      if (event.key === "Tab" || event.key === "Enter") {
        resetActiveState();
      }
    };

    document.addEventListener("keydown", handleTabPress);

    return () => {
      document.removeEventListener("keydown", handleTabPress);
    };
  }, [dropDownChanges]);

  const handleKycTypeChange = (value) => {
    // if (selectedKycType !== value) {
    //   form.setFieldValue("kycDocumentNo", null);
    // }
    form.setFields([
      {
        name: "kycDocumentNo",
        errors: [],
      },
    ]);
    setSelectedKycType(value);
  };

  const handleKeyDown = (
    event,
    dataOptions,
    formItemName,
    valueKey = "value"
  ) => {
    // event?.preventDefault();
    const activeOption = document.querySelector(
      ".ant-select-item-option-active"
    );

    const handleEnterKey = () => {
      toggleDropdown();
      // if (formItemName === "deliveryPincode") {
      //   if (activeOption) {
      //     const value = activeOption.getAttribute("title");
      //     form.setFieldsValue({ [formItemName]: value?.slice(0, 6) });
      //     console.log(value, "value");
      //     getDeliveryPincode(
      //       activePinOption,
      //       value,
      //       form.getFieldValue("service")
      //     );
      //   }
      // }
      handleOnEnter(event);
    };

    const handleTabKey = () => {
      toggleDropdown();
      if (activeOption) {
        const value = activeOption.getAttribute("title");

        if (formItemName === "deliveryPincode") {
          handleDeliveryPincode(value, dataOptions, formItemName);
        } else {
          handleOtherFields(value, dataOptions, formItemName);
        }
      }
    };

    const toggleDropdown = () => {
      setdropDownChanges((prevState) => !prevState);
    };

    const handleDeliveryPincode = (value, options, formItem) => {
      const slicedValue = value?.slice(0, 6);
      const optionExists = options?.some(
        (option) => option?.value == +slicedValue
      );
      if (optionExists) {
        form.setFieldsValue({ [formItem]: slicedValue });
        getDeliveryPincode(
          slicedValue,
          slicedValue,
          form.getFieldValue("service")
        );
      }
    };

    const handleOtherFields = (value, options, formItem) => {
      const optionExists = options?.some(
        (option) =>
          String(option?.value || "")?.toLowerCase() ===
          String(value || "")?.toLowerCase()
      );

      if (optionExists) {
        form.setFieldsValue({ [formItem]: value });

        switch (formItem) {
          case "shipmentType":
            handleShipmentType(value);
            break;
          case "kycDocumentType":
            handleKycTypeChange(value);
            break;
          case "travelBy":
            getRateCard(value);
            break;
          case "service":
            handleService(value);
            break;
          case "insured":
            getRateCard(value);
            break;

          default:
            break;
        }
      }
    };

    const handleShipmentType = (value) => {
      form.setFieldValue("content", null);
      const matchedOption = contentDiscriptionData?.shipmentType?.find(
        (option) =>
          option?.shipmentTypeName?.toUpperCase() === value?.toUpperCase()
      );
      const newVal = {
        key: matchedOption?.shipmentTypeId,
        value: matchedOption?.shipmentTypeName?.toUpperCase(),
      };
      handleShipmentTypeChange("_", newVal);
    };

    // Main switch block
    switch (event.key) {
      case "Enter":
        handleEnterKey();
        break;
      case "Tab":
        handleTabKey();
        break;
      default:
        break;
    }
  };

  const handleAPIKeyDown = (
    event,
    dataOptions,
    formItemName,
    formKeyName = "value",
    dropDownName
  ) => {
    switch (event.key) {
      case "Enter":
        event?.preventDefault();
        setdropDownChanges(!dropDownChanges);
        handleOnEnter(event);

        break;
      case "Tab":
        setdropDownChanges(!dropDownChanges);
        // eslint-disable-next-line no-case-declarations
        let activeOption = document.querySelector(
          ".ant-select-item-option-active"
        );

        if (activeOption) {
          // setdropDownChanges((prevState) => !prevState);
          const value = activeOption.getAttribute("title");

          const optionExists = dataOptions?.find(
            (option) =>
              option[formKeyName]?.toLowerCase() == value?.toLowerCase()
          );
          if (optionExists) {
            form.setFieldsValue({ [formItemName]: value });

            return;
          }
        }
        break;
      default:
        break;
    }
  };

  const settingDocFeild = (name, message) => {
    setDocValidate({ status: message ? "error" : null, message: message });
  };

  const handleService = (e) => {
    getRateCard(e);
  };

  let tempOptions = [
    {
      value: "STANDARD",
      label: "STANDARD",
    },
    {
      value: "FAST TRACK",
      label: "FAST TRACK",
    },
    { value: "VALUE PLUS", label: "VALUE PLUS" },
  ];

  const handleValidationError = (message) => {
    setdocLoading(false);
    setServiceOptions(tempOptions);
    settingDocFeild("documentNumber", message);
  };

  const handleServiceOptions = (serviceValue) => {
    const docTypeMapping = {
      FastTrack: "FAST TRACK",
      Standard: "STANDARD",
      ValuePlus: "VALUE PLUS",
    };

    // Map service values to display format
    const mappedServiceValue = serviceValue?.map((val) => docTypeMapping[val]);

    // Filter out VALUE PLUS option for non-Gujarat users
    const userInfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
    let availableOptions = [...tempOptions];

    if (userInfo?.state?.toUpperCase()?.trim() !== "GUJARAT") {
      availableOptions = availableOptions?.filter(
        (option) => option?.value !== "VALUE PLUS"
      );
    }

    // Filter options based on mapped service values
    return availableOptions?.filter((item) =>
      mappedServiceValue?.includes(item?.value)
    );
  };

  const handleFastTrackService = () => {
    form.setFieldValue("service", "FAST TRACK");

    const deliveryPincode = form.getFieldValue("deliveryPincode");
    if (deliveryPincode) {
      getDeliveryPincode(deliveryPincode, null, "FAST TRACK", true);
    }
  };

  const handleDocumentInputChange = async (e) => {
    let formDoc = form.getFieldValue("documentNumber")?.toString()?.trim();

    if (!formDoc) {
      console.log("documentNumber error", formDoc);
      message.error("Enter document number!");
      return;
    }

    // Clear any existing debounce timeout
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      if (formDoc?.length == 11 || formDoc?.length == 14) {
        // Validate client selection

        try {
          setdocLoading(true);

          const response = await documentValidate(
            form.getFieldValue("documentNumber")?.trim(),
            "Cash"
          );

          // Handle successful validation
          if (response?.response?.data?.data) {
            setdocLoading(false);
            settingDocFeild("documentNumber", null);

            const serviceValue = response?.response?.data?.data?.data || [];
            const nextInput = document.getElementById("deliveryPincode");
            if (nextInput) {
              nextInput.focus();
            }

            // Handle child badge courier case
            if (serviceValue && serviceValue[0] === "ChildBadgeCourier") {
              setServiceOptions([]);
              form.setFieldValue("service", null);
              settingDocFeild("documentNumber", "Child doc is not allowed");
              return;
            }

            // Handle service options
            const availableServices = handleServiceOptions(serviceValue);

            if (form.getFieldValue("documentNumber")?.length === 11) {
              handleFastTrackService();
            } else {
              setServiceOptions(availableServices);
              // form.setFieldValue("service", availableServices[0]?.value);
              form.setFieldValue("service", "STANDARD");
            }
            getRateCard();
          } else {
            handleValidationError(
              response?.response?.data?.message || "Network error!"
            );
          }
        } catch (error) {
          handleValidationError("Internal server error");
        }
      } else {
        handleValidationError("Document number must be 11 or 14 digits!");
      }
    }, 600);
  };

  const handlePincodeSearch = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      if (value?.length > 0) {
        const filtered = allPincodes
          ?.filter((item) => {
            const pincode = String(item?.Pincode);
            const searchValue = String(value);

            if (searchValue?.length === 6) {
              return pincode === searchValue;
            }

            return pincode?.startsWith(searchValue);
          })
          .map((item) => ({
            value: item?.Pincode,
            label: `${item?.Pincode}`,
          }));

        if (filtered?.length > 0) {
          setActivePinOption(filtered[0]?.value);
          setAllPinOptions(filtered);
        } else {
          setActivePinOption(null);
          setAllPinOptions([]);
        }
      } else {
        setActivePinOption(null);
        setAllPinOptions([]);
      }
    }, 100);
  };

  let contentDiscriptionOptions = contentDiscriptionData?.shipmentType?.map(
    (type) => ({
      value: type?.shipmentTypeName?.toUpperCase(),
      label: type?.shipmentTypeName?.toUpperCase(),
      key: type?.shipmentTypeId,
      id: type?.shipmentTypeId,
    })
  );

  const [number, setNumber] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      setNumber(18);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const currentEnv = process.env.REACT_APP_ENV;
  let disabled = editAwb && !enableForm;

  // console.log(checkStatus, "check");

  return (
    <>
      <Spin
        spinning={retailLoading || loading}
        indicator={
          <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
        }
      >
        <Row className="global-form-row" gutter={16}>
          <Col lg={6} sm={6}>
            <Form.Item
              label="Document Number"
              name="documentNumber"
              validateStatus={docValidate?.status}
              help={docValidate?.message}
              type="input"
              rules={[
                {
                  required: true,
                  message: "Enter document number",
                },
              ]}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  handleOnEnter(event);
                } else if (checkNumbervalue(event)) {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter document number"
                id="documentNumber"
                type="number"
                maxLength={14}
                disabled={disabled}
                onInput={(e) => preventTextPaste(e, 14)}
                // disabled={clientID == null}
                onChange={(e) => {
                  const value = e?.target?.value || "";
                  setTimeout(() => {
                    handleDocumentInputChange(value);
                  }, 50);
                }}
              />
            </Form.Item>
          </Col>

          <Col lg={8} sm={8} className="deliveryPinInput">
            <Form.Item
              name="deliveryPincode"
              label="Destination PIN code"
              defaultActiveFirstOption
              // className="pincode"
              validateStatus={pinCodeServiceableStatus?.status}
              help={pinCodeServiceableStatus?.msg}
              rules={[
                {
                  required: true,
                  message: "Enter destination pincode",
                },
                () => ({
                  validator(rule, value = "") {
                    if (value?.length > 0 && value?.length < 6) {
                      return Promise.reject("Pincode should be 6 digits");
                    } else {
                      return Promise.resolve();
                    }
                  },
                }),
              ]}
            >
              <AutoComplete
                disabled={disabled}
                options={allPinOptions}
                onSearch={handlePincodeSearch}
                onFocus={() => setdropDownChanges(!dropDownChanges)}
                defaultActiveFirstOption
                onSelect={(value, obj) => {
                  getDeliveryPincode(value, obj, form.getFieldValue("service"));
                }}
                onKeyDown={(event) => {
                  setActivePinOption(null);
                  handleKeyDown(
                    event,
                    allPinOptions,
                    "deliveryPincode",
                    "value"
                  );
                }}
              >
                <Input
                  type="number"
                  disabled={disabled}
                  // maxLength={6}
                  onInput={(e) => preventTextPaste(e, 6)}
                  onChange={(e) => {
                    if (e?.target?.value?.length == 6) {
                      if (debounceTimeoutPin.current) {
                        clearTimeout(debounceTimeoutPin.current);
                      }
                      debounceTimeoutPin.current = setTimeout(() => {
                        getDeliveryPincode(
                          e?.target?.value,
                          e,
                          form.getFieldValue("service")
                        );
                      }, 200);
                    } else {
                      setPinCodeServiceableStatus({
                        serviceability: null,
                        // status: "success",
                        msg: null,
                        stateCode: null,
                        city: null,
                        districtIp: null,
                      });
                    }
                  }}
                  placeholder="Enter destination pincode"
                  suffix={
                    pincodeLoading ? (
                      <Spin size="small" />
                    ) : (
                      <span
                        className={
                          pinCodeServiceableStatus?.serviceability
                            ? "green"
                            : "red"
                        }
                      >
                        <Tooltip
                          title={
                            pinCodeServiceableStatus?.city?.length > number
                              ? pinCodeServiceableStatus?.city
                              : null
                          }
                        >
                          {pinCodeServiceableStatus?.city?.length > number
                            ? pinCodeServiceableStatus?.city?.slice(0, number) +
                              "..."
                            : pinCodeServiceableStatus?.city}
                          {pinCodeServiceableStatus?.city ? "-" : null}
                          {pinCodeServiceableStatus?.stateCode}
                        </Tooltip>
                      </span>
                    )
                  }
                />
              </AutoComplete>
            </Form.Item>
          </Col>
          {enableDiscount && (
            <Col lg={10} sm={10} md={10}>
              <div style={{ width: "75%", marginRight: "8px" }}>
                <Form.Item
                  name="discountBooking"
                  rules={[
                    {
                      required: true,
                      message: "Select discount booking ",
                    },
                  ]}
                  label="Discount booking"
                >
                  <Select
                    showAction={["focus", "click"]}
                    disabled={disabled}
                    // disabled={disabledInput}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    onKeyDown={(event) =>
                      handleKeyDown(
                        event,
                        [
                          { value: "yes", label: "Yes" },
                          { value: "no", label: "No" },
                        ],
                        "discountBooking",
                        "discountBooking"
                      )
                    }
                    // onSelect={getRateCard}
                    // className="pincodeType-placecholder"
                    placeholder="Select discount booking"
                    // optionFilterProp="children"
                    options={[
                      { value: "yes", label: "Yes" },
                      { value: "no", label: "No" },
                    ]}
                  />
                </Form.Item>
              </div>
            </Col>
          )}
        </Row>

        <HeaderWithBottomLine text="Sender Details" icon={false} />
        <Row className="global-form-row" gutter={16}>
          <Col lg={6} sm={6}>
            <AutoSenderName
              form={form}
              disabled={disabled}
              fieldName="senderName"
              bookType={"Cash"}
              reviverNameAndAddress={reviverNameAndAddress?.senderDetails}
            />
          </Col>
          <SenderFormFields
            checkGST={checkGST}
            disabledFeilds={disabled}
            getSenderPincode={getSenderPincode}
            handleOnEnter={handleOnEnter}
            allPinOptions={allPinOptions}
            setSenderPinCodeServiceableStatus={
              setSenderPinCodeServiceableStatus
            }
            senderPinCodeServiceableStatus={senderPinCodeServiceableStatus}
            form={form}
            handleAPIKeyDown={handleAPIKeyDown}
            userInfo={userInfo}
            filterOption={filterOption}
            handleKeyDown={handleKeyDown}
            handleKycTypeChange={handleKycTypeChange}
            selectedKycType={selectedKycType}
            resetForm={resetForm}
            checkGSTStatus={checkGSTStatus}
          />
        </Row>
        <HeaderWithBottomLine text="Receiver Details" icon={false} />
        <Row className="global-form-row" gutter={16}>
          <ReciverAddressComponent
            form={form}
            disabledFeilds={disabled}
            bookType={"Cash"}
            handleOnEnter={handleOnEnter}
            reviverNameAndAddress={reviverNameAndAddress}
            parseInt={parseInt}
            resetForm={resetForm}
          />
        </Row>
        <HeaderWithBottomLine text="Service & Shipment Details" icon={false} />
        <Row className="global-form-row" gutter={16}>
          <div style={{ width: "14%", marginRight: "8px", marginLeft: "8px" }}>
            <Form.Item
              // style={{ width: "65%" }}
              name="shipmentType"
              label="Type"
              rules={[
                {
                  required: true,
                  message: "Enter value",
                },
              ]}
            >
              <Select
                showAction={["focus", "click"]}
                disabled={disabled}
                showSearch={true}
                placeholder="Select DOX type"
                className="shipmentType"
                onChange={handleShipmentTypeChange}
                onKeyDown={(event) =>
                  handleKeyDown(
                    event,
                    contentDiscriptionOptions,
                    "shipmentType",
                    "value"
                  )
                }
                options={contentDiscriptionOptions}
              ></Select>
            </Form.Item>
          </div>

          <div style={{ width: "33.33%", marginRight: "8px" }}>
            <Form.Item
              name="content"
              label="Content"
              rules={
                disabled
                  ? [] // No validation rules if field is disabled
                  : [
                      {
                        required: true,
                        message: "Select content",
                      },
                    ]
              }
            >
              <AutoComplete
                options={autoCompleteOptions}
                disabled={disabled}
                placeholder="Select a content"
                // optionFilterProp="children"
                onKeyDown={(event) =>
                  handleKeyDown(event, autoCompleteOptions, "content", "value")
                }
                filterOption={(inputValue, option) =>
                  option.value
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
              />
            </Form.Item>
          </div>

          {/* Hlloe dox anf non dx */}
          <RetailDoxAndNonDox
            disabledFeilds={disabled}
            isNonDox={isNonDox}
            shipmentContentOptions={shipmentContentOptions}
            childShipments={childShipments}
            handleOnEnter={handleOnEnter}
            // nonDoxValueReq={nonDoxValueReq}
            form={form}
          />

          <div style={{ width: "15%", marginRight: "8px" }}>
            <Form.Item
              name="travelBy"
              rules={[
                {
                  required: true,
                  message: "Select travel by ",
                },
              ]}
              label="Travel by"
            >
              <Select
                showAction={["focus", "click"]}
                disabled={disabled}
                // disabled={disabledInput}
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onKeyDown={(event) =>
                  handleKeyDown(event, travelByOptions, "travelBy", "value")
                }
                // onSelect={getRateCard}
                // className="pincodeType-placecholder"
                placeholder="Select  Travel by"
                // optionFilterProp="children"
                options={travelByOptions}
              />
            </Form.Item>
          </div>

          <div style={{ width: "15%", marginRight: "8px" }}>
            <Form.Item
              label="Service"
              name="service"
              rules={[
                {
                  required: true,
                  message: "Select service",
                },
              ]}
            >
              <Select
                showAction={["focus", "click"]}
                disabled={disabled}
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    ?.toLowerCase()
                    ?.includes(input?.toLowerCase())
                }
                // className="pincodeType-placecholder"
                popupClassName="credit-service-dropDown"
                placeholder="Select service"
                // optionFilterProp="children"
                options={servicesOptions}
                onChange={handleService}
                onKeyDown={(event) =>
                  handleKeyDown(event, servicesOptions, "service", "value")
                }
              ></Select>
            </Form.Item>
          </div>
          <div style={{ width: "12%", marginRight: "8px", marginLeft: "8px" }}>
            <Form.Item
              name="value"
              label="Value (INR)"
              rules={[
                {
                  required: isNonDox?.toUpperCase() === "NON-DOX", // Required only for NON-DOX
                  pattern: /^[0-9].*/g,
                  message: "Enter value",
                },
                ...(isNonDox?.toUpperCase() === "NON-DOX"
                  ? [
                      {
                        validator(rule, value = "") {
                          if (
                            parseInt(value?.toString()?.substring(1, 0)) === 0
                          ) {
                            return Promise.reject("Invalid value");
                          }
                          return Promise.resolve();
                        },
                      },
                    ]
                  : []), // Add validator only for NON-DOX
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  // handleOnEnter(event);
                  event?.preventDefault();
                  const inputFieldId = "insured";
                  const targetElement = document.getElementById(inputFieldId);
                  if (targetElement) {
                    targetElement?.focus();
                    targetElement?.select();
                  }
                } else if (checkNumbervalue(event) || event?.key === ".") {
                  event?.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter value"
                disabled={disabled}
                onInput={(e) => preventTextPaste(e, 9)}
                type="number"
                maxLength={9}
                onChange={(e) => {
                  const value = +e.target.value;
                  if (value > 50000) {
                    setEwayBillCheck(true);
                  } else {
                    setEwayBillCheck(false);
                  }

                  if (value > 1500000) {
                    setInsurenceCheck(false);
                  } else {
                    setInsurenceCheck(true);
                  }
                }}
              />
            </Form.Item>
          </div>

          <Col lg={4} sm={6} md={4}>
            <Form.Item
              validateStatus={mainEwayValidationStatus?.status}
              help={mainEwayValidationStatus?.msg}
              label={"Eway bill"}
              // disabled={edit !== null ? true : false}
              name="ewayBill0"
              // styles={styles}
              rules={[
                {
                  required: ewayBillCheck && allEwayBills?.length === 0,
                  message: "Enter Eway-bill",
                },
                // EwayValidator(),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event, "billRemark");
                } else if (checkNumbervalue(event) || event.key === ".") {
                  event.preventDefault();
                }
              }}
            >
              <Input
                maxLength={12}
                disabled={disabled}
                onInput={(e) => preventTextPaste(e, 12)}
                type="number"
                placeholder="Enter Eway-bill"
                onChange={(e) => {
                  if (e?.target?.value?.length == 0) {
                    setMainEwayValidationStatus({
                      status: "success",
                      msg: null,
                    });
                    let temp = [...allEwayBills]?.filter(
                      (val) => val?.editable == true
                    );
                    setAllEwayBills(temp);
                  } else {
                    if (debounceTimeout.current) {
                      clearTimeout(debounceTimeout.current);
                    }
                    debounceTimeout.current = setTimeout(async () => {
                      eWayBillHandle(e?.target?.value, 0);
                    }, 700);
                  }
                }}
              />
            </Form.Item>
          </Col>

          <div
            style={{ marginRight: "8px", paddingTop: "21px" }}
            className="flex-column"
          >
            <Button
              type="secondary"
              className={
                allEwayBills?.length > 0
                  ? "eway-Child-Active"
                  : "eway-Child-InActive"
              }
              // size={"large"}
              style={{
                height: "32px",
                width: "max-content",
                padding: "0 6px",
                display: "flex",
                alignItems: "center",
                fontSize: "12px",
              }}
              onFocus={applyFocusEffect}
              onBlur={removeFocusEffect}
              onClick={() => ewayDrawercallBack(true)}
            >
              <span>Multi E-ways</span>
              <DiffOutlined width={13} height={13} />{" "}
            </Button>
            <div>
              {allEwayBills?.length > 0 ? (
                <span style={{ color: "#50CD89", fontSize: "12px" }}>
                  {allEwayBills?.length} E-way Bill added
                </span>
              ) : null}
            </div>
          </div>

          {isNonDox == "NON-DOX" ? (
            <Col
              style={{ paddingTop: "24px", paddingRight: "5px" }}
              className="flex-column"
            >
              <Button
                type="secondary"
                className={
                  childShipments?.length > 0
                    ? "eway-Child-Active"
                    : "eway-Child-InActive"
                }
                // size={"large"}
                style={{
                  height: "30px",
                  // fontSize: "12px",
                  // width: "max-content",
                  justifyContent: "space-between",
                  padding: "0 6px",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => childDrawerCallBack(true)}
                onKeyPress={(e) =>
                  e.key === "Enter" && childDrawerCallBack(true)
                }
              >
                <span className="pr-05"> Child Badge</span>
                <AttachFile width={13} height={13} />
              </Button>
              <div>
                {childShipments?.length > 0 ? (
                  <span style={{ color: "#50CD89" }}>
                    {childShipments?.length} child added
                  </span>
                ) : null}
              </div>
            </Col>
          ) : null}

          <div style={{ width: "8%", marginRight: "8px" }}>
            <Form.Item
              name="insured"
              label="Insured"
              rules={[
                {
                  required: insurenceCheck,
                  message: "Select insured",
                },
              ]}
            >
              <Select
                showAction={["focus", "click"]}
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    ?.toLowerCase()
                    ?.includes(input?.toLowerCase())
                }
                onKeyDown={(event) =>
                  handleKeyDown(event, insuredOptions, "insured", "value")
                }
                onKeyPress={(event) => {
                  if (event.key == "Enter") {
                    handleOnEnter(event);
                  }
                }}
                className="pincodeType-placecholder"
                placeholder="Select insured"
                disabled={disabled}
                // optionFilterProp="children"
                options={insuredOptions}
              ></Select>
            </Form.Item>
          </div>
          <div style={{ width: "8%", marginRight: "8px" }}>
            <Form.Item
              label="Is Sez"
              name="IsSez"
              rules={[
                {
                  required: true,
                  message: "Select IsSez",
                },
              ]}
            >
              <Select
                showAction={["focus", "click"]}
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onKeyDown={(event) =>
                  handleKeyDown(event, sezOptions, "IsSez", "value")
                }
                onKeyPress={(event) => {
                  if (event.key == "Enter") {
                    handleOnEnter(event);
                  }
                }}
                className="pincodeType-placecholder"
                placeholder="Select service"
                options={sezOptions}
                disabled={disabled}
              />
            </Form.Item>
          </div>

          <div style={{ width: "10%", marginRight: "8px" }}>
            <Form.Item
              label="Payment"
              name="paymentMode"
              rules={[
                {
                  required: true,
                  message: "Select Pay",
                },
              ]}
            >
              <Select
                showAction={["focus", "click"]}
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onKeyDown={(event) =>
                  handleKeyDown(event, payOptions, "paymentMode", "value")
                }
                onKeyPress={(event) => {
                  if (event.key == "Enter") {
                    handleOnEnter(event);
                  }
                }}
                className="pincodeType-placecholder"
                placeholder="Select pay mode"
                options={payOptions}
                disabled={disabled}
              />
            </Form.Item>
          </div>

          <div style={{ width: "10%", marginRight: "8px" }}>
            <Form.Item
              label="Freight"
              name="freight"
              extra={
                isODAIncluded ? (
                  <div style={{ fontSize: "11px", color: "rgb(80, 205, 137)" }}>
                    <span>Additional charges: {isODAIncluded}</span>
                  </div>
                ) : null
              }
              rules={[
                {
                  required: true,
                  message: "Enter freight",
                },
                () => ({
                  validator(_, value) {
                    if (+value < +mainBaseCharge) {
                      return Promise.reject(
                        "Freight should not be less then " + mainBaseCharge
                      );
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event);
                } else if (
                  checkSpecialCharacter(event) ||
                  event.key === "." ||
                  checkNumbervalue(event)
                ) {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter freight"
                disabled={disabled}
                maxLength={7}
                onInput={(e) => preventTextPaste(e, 7)}
                type="number"
                onChange={onFreightChange}
              />
            </Form.Item>
          </div>

          <div style={{ width: "10%", marginRight: "8px" }}>
            <Form.Item
              label="PKg charge"
              name="pktCharge"
              rules={[
                {
                  required: false,
                  message: "Enter packaging charge",
                },
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  // handleOnEnter(event);
                  const inputFieldId = "submit_credit";
                  const targetElement = document.getElementById(inputFieldId);
                  if (targetElement) {
                    targetElement?.focus();
                    // targetElement?.select();
                  }
                  event.preventDefault();
                } else if (
                  checkSpecialCharacter(event) ||
                  event.key === "." ||
                  checkNumbervalue(event)
                ) {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter value"
                disabled={disabled}
                maxLength={7}
                onInput={(e) => preventTextPaste(e, 7)}
                type="number"
                onChange={onPacketChange}
              />
            </Form.Item>
          </div>

          <Col lg={4} sm={6}></Col>
        </Row>
      </Spin>
    </>
  );
}

export default NewRetailForm;
